// extracted by mini-css-extract-plugin
export default {"container":"LegalPage_container__PZ-1I","link":"LegalPage_link__n+oD2"};